export const GET_EXCEPTION_LOG_REQUEST = "GET_EXCEPTION_LOG_REQUEST";
export const GET_EXCEPTION_LOG_SUCCESS = "GET_EXCEPTION_LOG_SUCCESS";
export const GET_EXCEPTION_LOG_FAILURE = "GET_EXCEPTION_LOG_FAILURE";
